import React from 'react'
import {DraggableItem, DraggableContainer} from 'startlibs/lib/components'
import {EditableLabel} from '../../components/editableLabel'
import {Fill} from 'react-slot-fill'
import {ice} from 'icepath'
import {formatDate} from '../../components/datepicker'
import {connect} from 'react-redux'
import {dicomDateToDate} from '../../lib'

export class BasicInfoEditor extends React.Component {

  state = {}

  addNew = () => {
    this.setState({openId: this.props.newId})
    this.props.addNew({label: 'Field Label', value: '', id: this.props.newId})
  }

  remove = (basicInfo) => {
    const index = this.props.basicInfos.findIndex(id => id === basicInfo.id)
    this.setState({deletedBasicInfo: {index, basicInfo}})
    setTimeout(() => {
      if (this.state.deletedBasicInfo) {
        this.props.confirmRemoveItem(basicInfo.id)
        this.setState({deletedBasicInfo: null})
      }
    }, 10000)
    this.props.removeItem(basicInfo.id)
  }

  undoDelete = () => {
    const {basicInfo, index} = this.state.deletedBasicInfo
    this.props.addNew(basicInfo, index)
    this.setState({deletedBasicInfo: null})
  }

  setItemOrder = (from, to) => {
    const oldOrder = this.props.basicInfos.map(_ => _.id)
    const newOrder = ice(oldOrder).splice(from, 1).splice(to, 0, oldOrder[from]).value()
    this.props.updateOrder(newOrder)
  }

  render() {
    const {basicInfos, noHeader, errorsIds, noButton, labels, dicomInfo, updateItem, autoSaveUpdate, close, language, dateFormat} = this.props
    const {openId, deletedBasicInfo} = this.state
    return (
      <div className="report-basic-info-open">
        {
          !noHeader &&
          <div className="basic-info-header">
            <h4>Edit report basic information</h4>
            <button className="small-button close-button" onClick={close}>Done</button>
          </div>
        }
        <DraggableContainer setDragRef={this.props.setDragRef} setItemOrder={this.setItemOrder}
                            className="drag-drop-limits">
          {basicInfos.map((basicInfo, index) =>
            <BasicInfoField
              language={language}
              dateFormat={dateFormat}
              isLabelEditOpen={openId === basicInfo.id} key={basicInfo.id}
              index={index}
              hasErrors={(errorsIds || []).indexOf(basicInfo.id) >= 0}
              basicInfo={basicInfo}
              labels={labels}
              autoSaveUpdate={autoSaveUpdate}
              updateItem={updateItem}
              dicomInfo={dicomInfo}
              remove={this.remove}
            />)}
        </DraggableContainer>
        {!basicInfos.length &&
        <div className="empty-basic-info">You currently have no Basic Info fields. Click the button below to add
          one.</div>}
        <a className="button outline add-field-button" onClick={this.addNew}><span className="icon icon-plus-circle"/>Add
          field</a>
        <div className="force-hidden basic-info-footer">
          <span className="reorder-instruction">Drag and drop fields to reorder</span>
          {
            !noButton &&
            <button onClick={close}>Close</button>
          }
        </div>
        {deletedBasicInfo && <Fill name="Notifications">
          <div className="system-notification undo-notification">Basic Info successfully deleted <a
            className="button small-button" onClick={this.undoDelete}>Undo</a></div>
        </Fill>}
      </div>
    )
  }
}

@connect(
  (state, ownProps) => ({
    language: ownProps.language || state.reportSettings.layout.language,
    dateFormat: ownProps.dateFormat || state.reportSettings.layout.dateFormat
  })
)
class BasicInfoField extends React.Component {

  modified = false

  componentDidMount() {
    if (this.props.basicInfo.dicomField === 'dob' && this.props.basicInfo.value === '\u200B') {
      this.setFormattedDoB()
    }
  }

  deleteInfo = () => {
    this.props.remove(this.props.basicInfo)
  }

  handleChange = (e) => {
    this.modified = true
    this.props.updateItem({...this.props.basicInfo, value: e.target.value})
  }

  autoSave = () => {
    if (this.modified) {
      this.modified = false
      this.props.autoSaveUpdate(this.props.basicInfo)
    }
  }

  handleLabelChange = (label, dicomField) => {
    const basicInfo = (dicomField && this.props.dicomInfo[dicomField]) ? {
      ...this.props.basicInfo,
      label,
      value: dicomField !== 'dob' ? this.props.dicomInfo[dicomField] : '',
      dicomField
    } : {...this.props.basicInfo, label, dicomField}
    this.props.updateItem(basicInfo)
    this.modified = false
    this.props.autoSaveUpdate(basicInfo)

    if (dicomField === 'dob' && this.props.dicomInfo['dob']) {
      this.setFormattedDoB()
    }
  }

  setFormattedDoB() {
    const date = dicomDateToDate(this.props.dicomInfo['dob'])
    if (!isNaN(date.getTime())) {
      import(`../../components/date.i18n/${this.props.language}`)
        .then((lang) =>
          formatDate(date, lang[this.props.language], this.props.dateFormat)
        )
        .then(formattedDate => {
          const basicInfo = {...this.props.basicInfo, value: formattedDate}
          this.props.updateItem(basicInfo)
          this.props.autoSaveUpdate(basicInfo)
        })
    }
  }

  render() {
    const {basicInfo, hasErrors, labels, index, isLabelEditOpen} = this.props
    const labelList = () => labels.map((label, i) => <li key={i}
                                                         className={label.label === basicInfo.label ? 'selected' : ''}
                                                         onClick={() => this.handleLabelChange(label.label, label.dicomField)}>
      <a>{label.label}<span className="help-text">{label.auto ? '(auto-filled)' : ''}</span></a>
    </li>)
    return (
      <DraggableItem
        index={index}
        id={basicInfo.id}
        className={'report-field-item draggable-field-item' + (hasErrors ? ' has-errors' : '')}
      >
        <EditableLabel
          isLabelEditOpen={isLabelEditOpen}
          isContextMenuOpen={isLabelEditOpen}
          value={basicInfo.label}
          labelList={labelList}
          handleChange={this.handleLabelChange}
        />
        <input data-drag={false} onBlur={this.autoSave} type="text" name={'basicInfo' + basicInfo.id}
               value={basicInfo.value || ''} onChange={this.handleChange}/>
        <a data-drag={false} onClick={this.deleteInfo} className="icon icon-x"/>
      </DraggableItem>
    )
  }
}


@connect((state, ownProps) => ({
  dicomInfo: ownProps.dicomInfo || state.dicomInfo,
  language: ownProps.language || state.reportSettings.layout.language,
  dateFormat: ownProps.dateFormat || state.reportSettings.layout.dateFormat
}))
export class DicomDateFormatter extends React.Component {

  componentDidMount() {
    this.props.fields.forEach(field => {
      const unformattedDate = this.props.basicInfos.find(_=> _.dicomField === field && _.value === '\u200B')
      if (unformattedDate) {
        this.setFormattedDicomDate(unformattedDate,field)
      }
    })
  }

  setFormattedDicomDate(unformattedDob, field) {
    const date = dicomDateToDate(this.props.dicomInfo[field])
    if (!isNaN(date.getTime())) {
      import(`../../components/date.i18n/${this.props.language}`)
        .then((lang) =>
          formatDate(date, lang[this.props.language], this.props.dateFormat)
        )
        .then(formattedDate => {
          const basicInfo = {...unformattedDob, value: formattedDate}
          this.props.updateItem(basicInfo)
          this.props.autoSaveUpdate(basicInfo)
        })
    }
  }

  render() {
    return null
  }

}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/BasicInfo.js